import ListScreen, { ListScreenItem } from '@components/General/ListScreen';
import { Organization } from '@models/Organization';
import { AppRoutes } from '@models/AppRoutes';
import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as PlaneSVG } from '@assets/SVGs/Sidebar/Novedades/PlaneSVG.svg';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import { SystemIcon } from '@shared/designSystem/SystemIcon';
import designSystemStyles from '@shared/styles/designSystemStyles';
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined';
import TwoFactorAuthenticationModalScreen from './TwoFactorAuthentication/TwoFactorAuthenticationModalScreen';

interface ConfiguracionScreenProps {
	org: Organization;
}

const ConfiguracionScreen: React.FC<ConfiguracionScreenProps> = ({ org }) => {
	const navigate = useNavigate();
    const [isTwoFactorAuthenticationModalOpen, setIsTwoFactorAuthenticationModalOpen] = useState(false);

	const handleNavigation = (path: string, state: any) => {
        if (path === '/configuracion/2fa') {
            setIsTwoFactorAuthenticationModalOpen(true);
            return;
        }

		navigate(path, { state });
	};

	const screens = useMemo(() => {
        const screens: ListScreenItem[] = [];
        if (org.newFlags.NovedadesWeb) {
            screens.push({
                path: '/configuracion/novedades',
                label: 'Novedades'.localized(),
                state: { org: org },
                SvgComponent: (props) => <PlaneSVG/>,
            })
        }
        if (org.newFlags.AdminUserCreationWeb) {
            screens.push({
                path: '/configuracion/usuarios',
                label: 'Usuarios'.localized(),
                state: { org: org },
                SvgComponent: (props) => <PersonAddAltOutlinedIcon/>,
            })
            screens.push({
                path: AppRoutes.configuracionCamposColaborador,
                label: 'Campos colaboradores'.localized(),
                state: { org: org },
                SvgComponent: () => (
                    <SystemIcon
                        type="profile"
                        color={designSystemStyles.colorText}
                    />
                ),
            })
        }
        if (org.newFlags.QontactPointCreationWeb) {
            screens.push({
                path: AppRoutes.configuracionCamposQontactPoint,
                label: 'Campos de Qontact Points'.localized(),
                state: { org: org },
                SvgComponent: () => (
                    <SystemIcon
                        type="qr"
                        color={designSystemStyles.colorText}
                    />
                ),
            })
        }
        if (org.newFlags.Presenteeism2FA) {
            screens.push({
                path: '/configuracion/2fa',
                label: '2FA'.localized(),
                state: { org: org },
                SvgComponent: (props) => <SecurityOutlinedIcon {...props}/>,
            })
        }

        return screens;
    }, [org]);

	return (
        <>
			<ListScreen
				title="Configuración"
				org={org}
				onScreenClick={(screen) => handleNavigation(screen.path, screen.state)}
				screens={screens}
			/>
            <TwoFactorAuthenticationModalScreen
                isOpen={isTwoFactorAuthenticationModalOpen}
                onClose={() => setIsTwoFactorAuthenticationModalOpen(false)}
                org={org}
            />
        </>
		);
	};

export default ConfiguracionScreen;
